// @flow
import * as React from 'react'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { includes, find, map } from 'lodash/collection'
import { get } from 'lodash/object'
import { Helmet } from 'react-helmet'
import i18n from 'i18next'
import isBot from 'isbot'

import { appshellActions } from '@modules/appshell'
import { accountActions } from '@modules/account'
import { routerActions } from '@modules/router'
import { availableLanguages } from '../master/i18n'

type Props = {
  changeLanguage: Function,
  children: React.Node,
  flushTo: Function,
  hasLangPath: boolean,
  hasLegalAgeAccesGranted: boolean,
  hasUserLegalAge: boolean,
  isAtHomePage: boolean,
  isAuthenticated: boolean,
  kickOff: Function,
  langPath: any,
  language: string,
  navigateTo: Function,
  pathName: string,
  queryStringParams: string,
  verifyUserLegalAge: Function
}

export const mapDispatchToProps = (dispatch: Function) => ({
  kickOff: () => dispatch(appshellActions.kickOff()),
  navigateTo: (to: string) => dispatch(routerActions.navigateTo(to)),
  flushTo: (to: string) => dispatch(routerActions.flushTo(to)),
  verifyUserLegalAge: (hasUserLegalAge: boolean) => {
    return dispatch(appshellActions.verifyUserLegalAge(hasUserLegalAge))
  },
  changeLanguage: (language: string, isAuthenticated: boolean) => {
    return dispatch(accountActions.changeLanguage(language, isAuthenticated))
  }
})

const mapStatetoProps = (state: Object) => ({
  hasLangPath: find(
    map(availableLanguages, lang => lang.code),
    code =>
      includes(state.router.location.pathname.substring(0, 4), `/${code}/`)
  ),
  hasLegalAgeAccesGranted: includes(
    get(state, 'router.location.search'),
    'accessgranted=yes'
  ),
  hasUserLegalAge: state.appshell.hasUserLegalAge,
  isAuthenticated: !!state.auth.customerToken,
  isAtHomePage: !!find(
    map(availableLanguages, language => language.code),
    language => `/${language}` === state.router.location.pathname
  ),
  language: state.account.language,
  pathName: state.router.location.pathname,
  queryStringParams: state.router.location.search
})

export class AppshellContainer extends React.Component<Props> {
  constructor (props: Props) {
    super(props)
    if (this.props.pathName === '/') {
      return this.props.flushTo(i18n.t('routes.HOME'))
    }
    if (!this.props.hasLangPath && !this.props.isAtHomePage) {
      this.props.flushTo(i18n.t('routes.HOME') + this.props.pathName)
    }
  }

  componentDidMount () {
    this.props.kickOff()

    if (this.props.hasLegalAgeAccesGranted) {
      this.props.verifyUserLegalAge(true)
      return this.props.navigateTo(
        this.props.pathName + this.props.queryStringParams
      )
    }

    if (!isBot(window.navigator.userAgent) && !this.props.hasUserLegalAge) {
      this.props.flushTo(
        i18n.t('routes.STATIC_PAGE').replace(':page', 'legal-age') +
          this.props.queryStringParams
      )
    }
  }

  componentDidUpdate (prevProps: Object) {
    if (this.props.pathName !== prevProps.pathName) {
      if (!isBot(window.navigator.userAgent) && !this.props.hasUserLegalAge) {
        this.props.flushTo(
          i18n.t('routes.STATIC_PAGE').replace(':page', 'legal-age') +
            this.props.queryStringParams
        )
      }

      if (
        prevProps.pathName.includes('complot-ipa') &&
        this.props.pathName.includes('complot-ipa')
      ) {
        return
      }

      if (
        (prevProps.pathName.includes('free-damm-tostada') ||
          prevProps.pathName.includes('pack-free-damm-tostada') ||
          prevProps.pathName.includes('free-damm-torrada') ||
          prevProps.pathName.includes('pack-free-damm-torrada')) &&
        (this.props.pathName.includes('free-damm-tostada') ||
          this.props.pathName.includes('pack-free-damm-tostada') ||
          this.props.pathName.includes('free-damm-torrada') ||
          this.props.pathName.includes('pack-free-damm-torrada'))
      ) {
        return
      }

      window.scrollTo(0, 0)
    }
  }

  render () {
    return (
      <React.Fragment>
        <Helmet>
          <title>{i18n.t('appshell.seo.title')}</title>
          <script
            async
            src='https://www.googletagmanager.com/gtag/js?id=UA-21037369-11'
          />
          <script>{`
            window.dataLayer = window.dataLayer || [];
            function analytics(){dataLayer.push(arguments);}
            analytics('js', new Date());
            analytics('config', 'UA-21037369-11');
          `}</script>
          <script>{`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-WHXP6D7');
          `}</script>
          <style>{`.root { height: 100vh}`}</style>
        </Helmet>
        <Grid container>{this.props.children}</Grid>
      </React.Fragment>
    )
  }
}

export default connect(mapStatetoProps, mapDispatchToProps)(AppshellContainer)
